import { render, staticRenderFns } from "./HighlightHeaderSection.vue?vue&type=template&id=6faa0900&scoped=true"
import script from "./HighlightHeaderSection.vue?vue&type=script&lang=ts"
export * from "./HighlightHeaderSection.vue?vue&type=script&lang=ts"
import style0 from "./HighlightHeaderSection.vue?vue&type=style&index=0&id=6faa0900&prod&lang=scss&scoped=true"
import style1 from "./HighlightHeaderSection.vue?vue&type=style&index=1&id=6faa0900&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa0900",
  null
  
)

export default component.exports